import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ICatUbicaciones from '../../../Interfaces/Catalogos/ICatUbicaciones'
const CatUbicaciones: ICatUbicaciones[] = []
const initialState = { CatUbicaciones }

export const CatUbicacionesSlice = createSlice({
  name: 'CatUbicaciones',
  initialState: initialState,
  reducers: {
    resetCatUbicaciones : (state, action: PayloadAction<string>) => {
      state.CatUbicaciones =  []
    },  
    populateCatUbicaciones : (state, action: PayloadAction<ICatUbicaciones[]>) => {
        action.payload.forEach(element => {
            const index = state.CatUbicaciones.findIndex(object => object.id === element.id)
            if (index<0) state.CatUbicaciones.push(element)
        })
    },
    updateCatUbicaciones : (state, action: PayloadAction<ICatUbicaciones>) => {
      const i = state.CatUbicaciones.findIndex(_element => _element.id === action.payload.id);
      if (i > -1) state.CatUbicaciones[i] = action.payload;
      else state.CatUbicaciones.push(action.payload);
    },
    deleteCatUbicaciones : (state, action: PayloadAction<number>) => {
      const newArr = state.CatUbicaciones.filter(data => data.id != action.payload);
      state.CatUbicaciones=newArr
    },
  },
})

export const { resetCatUbicaciones, populateCatUbicaciones, updateCatUbicaciones, deleteCatUbicaciones } = CatUbicacionesSlice.actions;
export default CatUbicacionesSlice.reducer;